import { useQuery } from '@tanstack/react-query';
import { getNutritionByMealItem } from '../../../api/nutrition-service';

const useGetNutritionByMealItem = (mealItem) => {
    const { data, isLoading, isError, error } = useQuery({
        queryKey: ['nutrition', 'mealItem', mealItem],
        queryFn: () => getNutritionByMealItem(mealItem),
        enabled: !!mealItem,
        staleTime: 1000 * 60 * 5,
        keepPreviousData: true,
        refetchOnWindowFocus: false
    });

    return { data, isLoading, isError, error };
};

export default useGetNutritionByMealItem;
